import React, { useEffect, useState } from "react";
import axios from "axios";
import dayjs from "dayjs";
import styled from "styled-components";

import { Pagination, Spin, Table } from "antd";

import { handleError } from "../../../modules/presence/sagas";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 20px;
`;

const baseapi = process.env.REACT_APP_API + "/api";
const PAGE_SIZE = 10;

const RequestsList = ({ token }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState();

  const fetchRequests = async () => {
    setIsLoading(true);
    try {
      const result = await axios.post(
        `${baseapi}/requests`,
        {
          match: { type: "pdc_update" },
          sort: { created_at: -1 },
          page,
          pageSize: PAGE_SIZE
        },
        {
          headers: {
            Authorization: token
          }
        }
      );

      setData(result.data.docs);

      setTotal(result.data.total);
    } catch (e) {
      handleError(e);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    fetchRequests();
  }, [page]);
  const columns = [
    {
      title: "pdc",
      dataIndex: "pdc_label",
      key: "pdc_label",
      render: (text, record) => {
        if (!record) {
          return <span> {`Aucun pdc`}</span>;
        }
        const { infos } = record;
        if (!infos) {
          return <span> {`Aucun pdc`}</span>;
        }
        return (
          <div>
            <span>{`${infos.pdc_label}`}</span>
            <span>{`(${infos.pdc_id})`}</span>
          </div>
        );
      }
    },
    {
      title: "Date de la demande",
      dataIndex: "created_at",
      key: "created_at",
      render: date => {
        return <span> {`${dayjs(date).format("DD-MM-YYYY HH:mm")}`}</span>;
      }
    },
    {
      title: "Demandeur",
      dataIndex: "user_email",
      key: "user_email",
      render: (text, record) => {
        const { infos } = record;
        return <span>{infos.user_email}</span>;
      }
    },
    {
      title: "status",
      dataIndex: "status_label",
      key: "status_label"
    },
    {
      title: "Modifications",
      dataIndex: "data",
      key: "data",
      render: data => {
        if (!data) {
          return <span>aucune modification</span>;
        }
        return (
          <div>
            {Object.keys(data).map((key, i) => {
              if (key === "pdc_id") {
                return null;
              }
              if (typeof data[key] === "object") {
                return null;
              }
              return (
                <div key={i}>
                  {key} : {data[key]}
                </div>
              );
            })}
          </div>
        );
      }
    },
    {
      title: "validé par",
      dataIndex: "infos",
      key: "infos",
      render: (infos, record) => {
        if (!infos) {
          return <span>info manquante</span>;
        }
        const { validated_by } = infos;
        if (!validated_by) {
          return <span>non validé</span>;
        }
        return (
          <div>
            <div>{validated_by.user_email}</div>
            <div>{dayjs(validated_by.date).format("DD-MM-YYYY HH:mm")}</div>
          </div>
        );
      }
    },
    {
      title: "Date dernière action",
      dataIndex: "updated_at",
      key: "updated_at",
      render: updated_at => {
        return <span> {`${dayjs(updated_at).format("DD-MM-YYYY HH:mm")}`}</span>;
      }
    }
  ];
  return (
    <Container>
      <HeaderContainer>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
          <div style={{ fontSize: 30, width: "30%" }}>{`Liste des requêtes`}</div>
        </div>
        <div style={{ width: "30%" }} />
      </HeaderContainer>
      <React.Fragment>
        {isLoading ? (
          <Spin />
        ) : (
          <Table rowKey="_id" columns={columns} dataSource={data} pagination={false} align="center" />
        )}
        <Pagination defaultCurrent={1} total={total} onChange={setPage} />
      </React.Fragment>
    </Container>
  );
};

export default RequestsList;



// WEBPACK FOOTER //
// src/containers/metier/requests/RequestsList.js